"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * States of the widget controller.
 */
var WidgetFlowState;
(function (WidgetFlowState) {
    WidgetFlowState["IDLE"] = "idle";
    WidgetFlowState["BLOCKED"] = "blocked";
    WidgetFlowState["CHECKING_SKIP_STEP"] = "skip check step";
    WidgetFlowState["INITIALIZING_STEP"] = "initializing step";
    WidgetFlowState["RENDERING_STEP"] = "rendering step";
    WidgetFlowState["REGISTERING_STEP"] = "registering step";
    WidgetFlowState["DISABLING_STEP"] = "disabling step";
    WidgetFlowState["DESTROYING_STEP"] = "destroying step";
    WidgetFlowState["DESTROYED"] = "destroyed";
})(WidgetFlowState = exports.WidgetFlowState || (exports.WidgetFlowState = {}));
